import { render, staticRenderFns } from "./FileArea.vue?vue&type=template&id=70850c20&"
import script from "./FileArea.vue?vue&type=script&lang=ts&"
export * from "./FileArea.vue?vue&type=script&lang=ts&"
import style0 from "./FileArea.vue?vue&type=style&index=0&id=70850c20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports